const EmptyList = () => (
  <div className="flex flex-col justify-center p-5 bg-gray-100 rounded-lg shadow-lg mt-4">
    <span className="text-xl font-semibold text-slate-700">Список пуст...</span>
  </div>
)

export default EmptyList
